import { ArchiveIcon } from "lucide-react";

import {
  AlertDialog,
  AlertDialogClose,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogPopup,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog";
import { Button } from "~/components/ui/button";

interface ProjectTaskArchiveDialogProps {
  readonly open: boolean;
  readonly taskId: number;
  readonly pending: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly onConfirm: () => Promise<void>;
}

export function ProjectTaskArchiveDialog(props: ProjectTaskArchiveDialogProps) {
  return (
    <AlertDialog
      open={props.open}
      onOpenChange={(open) => {
        if (!props.pending) props.onOpenChange(open);
      }}
    >
      <AlertDialogPopup className="max-w-sm">
        <AlertDialogHeader>
          <AlertDialogTitle>Archive task #{props.taskId}?</AlertDialogTitle>
          <AlertDialogDescription className="leading-5">
            This task will move out of active views. You can restore it later.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogClose
            disabled={props.pending}
            render={<Button type="button" variant="outline" />}
          >
            Cancel
          </AlertDialogClose>
          <Button
            type="button"
            variant="destructive"
            disabled={props.pending}
            onClick={() => void props.onConfirm()}
          >
            <ArchiveIcon aria-hidden />
            {props.pending ? "Archiving…" : "Archive task"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogPopup>
    </AlertDialog>
  );
}
